import React from "react"
import scrollTo from "gatsby-plugin-smoothscroll"
const Navbar = () => {
  return (
    <div className="section">
      <div className="container">
        <div className="navbar-wrapper">
          <div
            role="button"
            onClick={() => scrollTo("#home")}
            className="name"
            tabIndex={0}
          >
          </div>
          <div className="links-wrapper">
            <button onClick={() => scrollTo("#work")}>I miei lavori</button>
            <button onClick={() => scrollTo("#about")}>Chi sono</button>
            <button onClick={() => scrollTo("#contact")}>Contatti</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar
